/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Imgdesign_Err_Badges_Many1Inputs */

const vi_imgdesign_err_badges_many1 = /** @type {(inputs: Imgdesign_Err_Badges_Many1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chỉ chọn tối đa ${i?.max} logo chứng nhận`)
};

/**

* @param {Imgdesign_Err_Badges_Many1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const imgdesign_err_badges_many1 = /** @type {((inputs: Imgdesign_Err_Badges_Many1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Imgdesign_Err_Badges_Many1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_imgdesign_err_badges_many1(inputs)
});
export { imgdesign_err_badges_many1 as "imgDesign_err_badges_many" }